import React, { useEffect, useState } from 'react';
import { Phone, Menu, X, MapPin, Clock, Mail, Facebook, Instagram, ShieldCheck, ChevronRight } from 'lucide-react';
export const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className="fixed top-0 left-0 right-0 z-50" data-id="element-318">
      {/* Top utility bar */}
      <div className="hidden md:block bg-brand-black text-zinc-300 text-xs border-b border-zinc-800" data-id="element-319">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-9 flex items-center justify-between" data-id="element-320">
          <div className="flex items-center gap-6" data-id="element-321">
            <span className="flex items-center gap-1.5" data-id="element-322">
              <MapPin className="w-3.5 h-3.5 text-brand-red" data-id="element-323" /> Serving Central
              Valley, CA
            </span>
            <span className="flex items-center gap-1.5" data-id="element-324">
              <Clock className="w-3.5 h-3.5 text-brand-red" data-id="element-325" /> Open 7 Days •
              7:00 AM – 7:00 PM
            </span>
            <span className="flex items-center gap-1.5" data-id="element-326">
              <ShieldCheck className="w-3.5 h-3.5 text-brand-red" data-id="element-327" /> Licensed &
              Insured
            </span>
          </div>
          <div className="flex items-center gap-4" data-id="element-328">
            <a href="mailto:Jezjunksolution@gmail.com" className="flex items-center gap-1.5 hover:text-white transition-colors" data-id="element-329">
              <Mail className="w-3.5 h-3.5 text-brand-red" data-id="element-330" />
              Jezjunksolution@gmail.com
            </a>
            <span className="text-zinc-500" data-id="element-331">|</span>
            <a href="https://www.facebook.com/profile.php?id=61573603221493" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="hover:text-white transition-colors" data-id="element-332">
              <Facebook className="w-3.5 h-3.5" data-id="element-333" />
            </a>
            <a href="https://instagram.com/jezjunkaway" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="hover:text-white transition-colors" data-id="element-334">
              <Instagram className="w-3.5 h-3.5" data-id="element-335" />
            </a>
            <a href="https://tiktok.com/@jezjunkawaysolutions" target="_blank" rel="noopener noreferrer" aria-label="TikTok" className="hover:text-white transition-colors" data-id="element-336">
              <svg viewBox="0 0 24 24" fill="currentColor" className="w-3.5 h-3.5" data-id="element-337">
                <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.84-.1z" data-id="element-338" />
              </svg>
            </a>
          </div>
        </div>
      </div>

      {/* Main bar */}
      <div className={`bg-white transition-shadow ${scrolled ? 'shadow-lg' : 'border-b border-zinc-200'}`} data-id="element-339">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-24 md:h-28 flex items-center justify-between" data-id="element-340">
          <a href="#" className="flex items-center gap-3" data-id="element-341">
            <img src="https://cdn.magicpatterns.com/uploads/vWKqmdVYNC9wCEg3vWukxp/Photoroom_20260602_081134.png" alt="Jez Junk Away Solution" className="h-20 md:h-24 w-auto object-contain drop-shadow-sm" data-id="element-342" />
          </a>

          <nav className="hidden md:flex items-center gap-8" data-id="element-343">
            {[{
            label: 'Services',
            href: '#services'
          }, {
            label: 'Gallery',
            href: '#gallery'
          }, {
            label: 'Process',
            href: '#process'
          }, {
            label: 'Areas',
            href: '#areas'
          }, {
            label: 'Reviews',
            href: '#reviews'
          }, {
            label: 'FAQ',
            href: '#faq'
          }].map(item => <a key={item.href} href={item.href} className="text-sm font-semibold text-zinc-700 hover:text-brand-red transition-colors relative group" data-id="element-344">
                {item.label}
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-brand-red group-hover:w-full transition-all duration-300" data-id="element-345"></span>
              </a>)}
          </nav>

          <div className="hidden md:flex items-center gap-3" data-id="element-346">
            <div className="text-right" data-id="element-347">
              <p className="text-[10px] uppercase tracking-wider text-zinc-500 font-bold" data-id="element-348">
                24/7 Hotline
              </p>
              <a href="tel:+15597709442" className="font-oswald text-lg font-bold text-brand-black hover:text-brand-red transition-colors leading-none" data-id="element-349">
                (559) 770-9442
              </a>
            </div>
            <a href="tel:+15597709442" className="flex items-center gap-2 bg-brand-red hover:bg-brand-darkred text-white px-5 py-3 rounded-sm font-bold text-sm transition-all uppercase tracking-wide shadow-md hover:shadow-lg" data-id="element-350">
              <Phone className="w-4 h-4" data-id="element-351" />
              Free Quote
            </a>
          </div>

          <button className="md:hidden p-2 text-zinc-900" onClick={() => setIsOpen(!isOpen)} aria-label="Toggle menu" data-id="element-352">
            {isOpen ? <X className="w-6 h-6" data-id="element-353" /> : <Menu className="w-6 h-6" data-id="element-354" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {isOpen && <div className="md:hidden bg-white border-b border-zinc-200 px-4 py-4 flex flex-col gap-1 shadow-lg" data-id="element-355">
          {[{
        label: 'Services',
        href: '#services'
      }, {
        label: 'Gallery',
        href: '#gallery'
      }, {
        label: 'Process',
        href: '#process'
      }, {
        label: 'Areas',
        href: '#areas'
      }, {
        label: 'Reviews',
        href: '#reviews'
      }, {
        label: 'FAQ',
        href: '#faq'
      }].map(item => <a key={item.href} href={item.href} onClick={() => setIsOpen(false)} className="flex items-center justify-between py-3 px-2 border-b border-zinc-100 text-base font-semibold text-zinc-900" data-id="element-356">
              {item.label}
              <ChevronRight className="w-4 h-4 text-zinc-400" data-id="element-357" />
            </a>)}
          <a href="tel:+15597709442" className="flex items-center justify-center gap-2 bg-brand-red text-white px-6 py-4 rounded-sm font-bold w-full mt-4 uppercase" data-id="element-358">
            <Phone className="w-5 h-5" data-id="element-359" />
            Call (559) 770-9442
          </a>
        </div>}
    </header>;
};
const legalContent = {
  terms: {
    title: 'Terms of Service',
    body: [{
      h: 'Acceptance of Terms',
      p: 'By scheduling or using any junk removal, debris hauling, or cleanout service from Jez Junk Away Solution ("we," "us," "our"), you agree to these Terms of Service. If you do not agree, please do not use our services.'
    }, {
      h: 'Estimates & Pricing',
      p: 'All estimates are free and provided in good faith based on the information, photos, or descriptions you provide. Final pricing is confirmed on-site before work begins and may vary if the actual volume, weight, or type of items differs from what was described. You will always approve the final price before we start.'
    }, {
      h: 'Scheduling & Availability',
      p: 'We serve the Central Valley, CA, 7 days a week from 7:00 AM to 7:00 PM. Appointment times are estimates and may shift due to weather, traffic, or prior jobs running long. We will communicate any delays as soon as possible.'
    }, {
      h: 'Items We Remove',
      p: 'We remove most household, yard, construction, and commercial junk. We cannot accept hazardous materials (including chemicals, asbestos, wet paint, or biohazards) unless arranged in advance. We reserve the right to decline any item at our discretion.'
    }, {
      h: 'Property & Liability',
      p: 'Our crew takes care to protect your property. We are licensed and insured; however, we are not liable for pre-existing damage or for normal wear that may occur during the safe removal of large or heavy items. Please clear a path and notify us of any fragile surfaces in advance.'
    }, {
      h: 'Payment',
      p: 'Payment is due upon completion of the job unless otherwise agreed in writing. We accept common payment methods. Prices quoted are exclusive of any applicable taxes or disposal surcharges, which will be disclosed before work begins.'
    }, {
      h: 'Contact',
      p: 'Questions about these terms? Call or text us at (559) 770-9442 or email Jezjunksolution@gmail.com.'
    }]
  },
  privacy: {
    title: 'Privacy Policy',
    body: [{
      h: 'Information We Collect',
      p: 'When you contact us by phone, text, email, or social media, we may collect your name, phone number, email address, service address, and any photos or details you share about your job. We only collect what we need to provide a quote and complete your service.'
    }, {
      h: 'How We Use Your Information',
      p: 'We use your information solely to respond to inquiries, provide estimates, schedule and perform services, and follow up about your job. We do not sell, rent, or trade your personal information to third parties.'
    }, {
      h: 'Text & Photo Messages',
      p: 'Photos you text us for estimates are used only to assess your job and prepare a quote. We may, with your permission, feature before/after photos of completed work in our gallery or social media. Let us know if you prefer your job not be shared.'
    }, {
      h: 'Data Retention & Security',
      p: 'We retain your information only as long as needed to serve you and meet legal obligations. We take reasonable steps to protect your information, though no method of transmission is 100% secure.'
    }, {
      h: 'Your Choices',
      p: 'You may request that we update or delete your contact information at any time by calling or texting (559) 770-9442 or emailing Jezjunksolution@gmail.com.'
    }]
  }
} as const;
const LegalModal = ({
  type,
  onClose
}: {
  type: 'terms' | 'privacy';
  onClose: () => void;
}) => {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [onClose]);
  const content = legalContent[type];
  return <div className="fixed inset-0 z-[120] bg-brand-black/80 backdrop-blur-sm flex items-end md:items-center justify-center p-0 md:p-4" onClick={onClose} role="dialog" aria-modal="true" aria-label={content.title} data-id="element-360">
      <div className="bg-white w-full md:max-w-2xl md:rounded-sm shadow-2xl max-h-[90vh] flex flex-col animate-in slide-in-from-bottom md:zoom-in-95 duration-200" onClick={e => e.stopPropagation()} data-id="element-361">
        {/* Header */}
        <div className="flex items-center justify-between p-5 md:p-6 border-b border-zinc-200 shrink-0" data-id="element-362">
          <div className="flex items-center gap-3" data-id="element-363">
            <div className="w-1.5 h-8 bg-brand-red rounded-full" data-id="element-364" />
            <h2 className="font-oswald text-2xl font-bold uppercase text-brand-black" data-id="element-365">
              {content.title}
            </h2>
          </div>
          <button onClick={onClose} aria-label="Close" className="w-10 h-10 flex items-center justify-center rounded-sm text-zinc-500 hover:bg-zinc-100 hover:text-brand-red transition-colors" data-id="element-366">
            <X className="w-5 h-5" data-id="element-367" />
          </button>
        </div>

        {/* Body */}
        <div className="overflow-y-auto p-5 md:p-6 space-y-6" data-id="element-368">
          <p className="text-xs text-zinc-400 uppercase tracking-wider font-semibold" data-id="element-369">
            Last updated{' '}
            {new Date().toLocaleDateString('en-US', {
            month: 'long',
            year: 'numeric'
          })}
          </p>
          {content.body.map((section, i) => <div key={i} data-id="element-370">
              <h3 className="font-oswald text-lg font-bold uppercase text-brand-black mb-1.5" data-id="element-371">
                {section.h}
              </h3>
              <p className="text-zinc-600 text-sm leading-relaxed" data-id="element-372">
                {section.p}
              </p>
            </div>)}
        </div>

        {/* Footer */}
        <div className="p-5 md:p-6 border-t border-zinc-200 shrink-0 flex justify-end" data-id="element-373">
          <button onClick={onClose} className="bg-brand-red hover:bg-brand-darkred text-white px-6 py-3 rounded-sm font-oswald font-bold uppercase tracking-wide text-sm transition-colors" data-id="element-374">
            Close
          </button>
        </div>
      </div>
    </div>;
};
export const Footer = () => {
  const [legal, setLegal] = useState<'terms' | 'privacy' | null>(null);
  return <footer className="bg-brand-black text-white border-t-4 border-brand-red" data-id="element-375">
      {/* Top CTA strip */}
      <div className="bg-brand-red" data-id="element-376"></div>

      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid md:grid-cols-2 lg:grid-cols-4 gap-10" data-id="element-377">
        <div className="flex flex-col items-center text-center space-y-4" data-id="element-378">
          <img src="https://cdn.magicpatterns.com/uploads/vWKqmdVYNC9wCEg3vWukxp/Photoroom_20260602_081134.png" alt="Jez Junk Away Solution" className="h-28 md:h-32 w-auto object-contain drop-shadow-lg" data-id="element-379" />
          <p className="text-zinc-400 text-sm leading-relaxed" data-id="element-380">
            The Central Valley's full-service junk and debris removal team. We
            remove what nobody else will — fast, professionally, and at a price
            that makes sense.
          </p>
          <div className="flex flex-col gap-2 pt-2 text-sm w-full" data-id="element-381">
            <a href="tel:+15597709442" className="flex items-center justify-center gap-2 text-zinc-300 hover:text-brand-red transition-colors font-semibold" data-id="element-382">
              <Phone className="w-4 h-4 text-brand-red" data-id="element-383" />
              (559) 770-9442
            </a>
            <a href="mailto:Jezjunksolution@gmail.com" className="flex items-center justify-center gap-2 text-zinc-300 hover:text-brand-red transition-colors font-semibold break-all" data-id="element-384">
              <Mail className="w-4 h-4 text-brand-red" data-id="element-385" />
              Jezjunksolution@gmail.com
            </a>
            <div className="flex items-start justify-center gap-2 text-zinc-300 font-semibold" data-id="element-386">
              <Clock className="w-4 h-4 text-brand-red mt-0.5 shrink-0" data-id="element-387" />
              <div className="text-center leading-tight" data-id="element-388">
                <p data-id="element-389">Open 7 Days a Week</p>
                <p className="text-zinc-400 text-xs font-normal" data-id="element-390">
                  7:00 AM – 7:00 PM
                </p>
              </div>
            </div>
          </div>
          <div className="flex gap-3 pt-2 justify-center" data-id="element-391">
            <a href="https://www.facebook.com/profile.php?id=61573603221493" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="w-9 h-9 bg-zinc-800 hover:bg-brand-red flex items-center justify-center rounded-sm transition-colors" data-id="element-392">
              <Facebook className="w-4 h-4" data-id="element-393" />
            </a>
            <a href="https://instagram.com/jezjunkaway" target="_blank" rel="noopener noreferrer" aria-label="Instagram @jezjunkaway" className="w-9 h-9 bg-zinc-800 hover:bg-brand-red flex items-center justify-center rounded-sm transition-colors" data-id="element-394">
              <Instagram className="w-4 h-4" data-id="element-395" />
            </a>
            <a href="https://tiktok.com/@jezjunkawaysolutions" target="_blank" rel="noopener noreferrer" aria-label="TikTok @jezjunkawaysolutions" className="w-9 h-9 bg-zinc-800 hover:bg-brand-red flex items-center justify-center rounded-sm transition-colors" data-id="element-396">
              <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4" data-id="element-397">
                <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.84-.1z" data-id="element-398" />
              </svg>
            </a>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-zinc-800" data-id="element-399">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col md:flex-row justify-between items-center gap-3 text-xs text-zinc-500" data-id="element-400">
          <p data-id="element-401">
            © {new Date().getFullYear()} Jez Junk Away Solution. All rights
            reserved.
          </p>
          <p className="font-oswald uppercase tracking-wider text-zinc-400" data-id="element-402">
            "We Remove Anything. From Anywhere. No Excuses."
          </p>
          <div className="flex gap-4" data-id="element-403">
            <button onClick={() => setLegal('privacy')} className="hover:text-white transition-colors" data-id="element-404">
              Privacy
            </button>
            <button onClick={() => setLegal('terms')} className="hover:text-white transition-colors" data-id="element-405">
              Terms
            </button>
          </div>
        </div>
      </div>

      {legal && <LegalModal type={legal} onClose={() => setLegal(null)} data-id="element-406" />}
    </footer>;
};